/** @format */

import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import Modal from 'react-modal'
import { useCookies } from 'react-cookie'
import IPData from 'ipdata'

// import { Event } from '../../tracking'
import { useGA4React } from 'ga-4-react'

import {
  Container,
  GameLogo,
  Spacer,
  SuccessView,
  HowToPlay,
  ControlsHint,
  Countdown,
  GameOver,
  TimeoutModal,
  TnCs,
  useGameState,
} from '../../components'
import {
  refreshWindowSize,
  useDeviceOrientation,
  is_touch_device,
} from '../../utils'
import { initGame } from './game'

import './style.css'

const debug = false
const maxCount = 20

const mobileBlocksPerLevel = 40
const desktopBlocksPerLevel = 66

const gameTimeLimitMobile = 17
const gameTimeLimitDesktop = 60

Modal.setAppElement('#root')
export function AddToBasket(props) {
  const {
    // state,
    startGameState,
    howToPlay,
    timeout,
    submitted,
    finished,
    restart,
    //
    isStarted,
    isHowToPlay,
    isPlaying,
    didFinish,
    didSubmit,
    isEnded,
  } = useGameState()

  const [collectCount, setCollectedCount] = useState(0)
  const [cookies, setCookie] = useCookies(['validateAge', 'ipData'])
  const [notOldEnough, setNotOldEnough] = useState(false)

  const [countInModal, setCountInModal] = useState(true)
  const [userCountIn, setUserCountIn] = useState(3)
  const [userEmailRef, setUserEmailRef] = useState('')
  const [orientationWarning, setOrientationWarning] = useState(false)
  const [tncsView, setTncsView] = useState(false)

  const ga = useGA4React()

  useEffect(() => {
    refreshWindowSize()

    checkIP()

    if (window.orientation >= 90 || window.orientation <= -90)
      setOrientationWarning(true)

    window.addEventListener('orientationchange', checkOrientation)

    return () => {
      window.addEventListener('orientationchange', checkOrientation)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (isPlaying && userCountIn >= 0)
      setTimeout(() => {
        setUserCountIn(prevState => prevState - 1)
      }, 1000)

    if (isPlaying && userCountIn <= 0) setCountInModal(false)
    if (!isPlaying && userCountIn < 0) setUserCountIn(3)

    return () => {
      setCountInModal(true)
    }
  }, [userCountIn, isPlaying])

  useEffect(() => {
    if (isPlaying) window.addEventListener('unload', onAbandonGame)

    return () => {
      window.removeEventListener('unload', onAbandonGame)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPlaying])

  useDeviceOrientation()

  const openTncs = () => {
    setTncsView(!tncsView)
    ga.event('terms_&_conditions_click', 'Flavour Drop')
  }

  const infoModalClasses = {
    base: 'info-modal',
    afterOpen: 'info-modal--after-open',
    beforeClose: 'info-modal--before-close',
  }
  const infoModalOverlayClasses = {
    base: 'info-modal-overlay',
    afterOpen: 'info-modal-overlay--after-open',
    beforeClose: 'info-modal-overlay--before-close',
  }

  const checkIP = () => {
    const apiKey = 'b4ee7dc9e2662b200acfca7195d56248dd66b419f81246601b0640ec'
    const ipData = new IPData(apiKey)
    const ipDataFields = ['ip', 'country_code']
    const redirectURL = 'https://vuse.com'

    let userCountry
    let shouldRedirect = false

    const redirect = JSON.parse(sessionStorage.getItem('redirect'))
    if (redirect === true) window.location.replace(redirectURL)

    if (sessionStorage.getItem('redirect') === null) {
      ipData.lookup(null, null, ipDataFields).then(data => {
        userCountry = data.country_code

        if (userCountry === 'US') shouldRedirect = true

        sessionStorage.setItem('redirect', JSON.stringify(shouldRedirect))
        if (shouldRedirect === true) window.location.replace(redirectURL)
      })
    }
  }

  const addAgeCookie = () => {
    // Give cookies an expiration date
    const date = new Date()
    date.setDate(date.getDate() + 30)

    setCookie('validateAge', 'true', {
      expires: date,
    })
  }

  const makeUserEmailRef = userEmail => {
    setUserEmailRef(userEmail)
  }

  const ageGateRedirect = () => {
    setNotOldEnough(true)

    setTimeout(() => {
      window.location.replace('https://google.com')
    }, 4000)
  }

  const onAbandonGame = e => {
    e.preventDefault()
    ga.event('game_abandoned', 'Flavour Drop')
  }

  const onPressStart = () => {
    setCollectedCount(0)
    startGameState()
    setTimeout(() => {
      initGame({
        debug,
        onCollect: setCollectedCount,
        blocksPerLevel: is_touch_device()
          ? mobileBlocksPerLevel
          : desktopBlocksPerLevel,
      })
    }, 2000)
  }

  const onGameRestart = () => {
    restart()
    setCollectedCount(0)
    startGameState()
    setTimeout(() => {
      initGame({
        debug,
        onCollect: setCollectedCount,
        blocksPerLevel: is_touch_device()
          ? mobileBlocksPerLevel
          : desktopBlocksPerLevel,
      })
    }, 2000)
  }

  const onTimeout = () => {
    if (collectCount >= maxCount) {
      finished()
    } else {
      timeout()
    }
  }

  const onPlaying = () => {
    if (collectCount >= maxCount) {
      finished()
    } else {
      return true
    }
  }

  const onHowToPlay = () => {
    howToPlay()
  }

  const checkOrientation = () => {
    if (window.orientation >= 90 || window.orientation <= -90)
      setOrientationWarning(true)
    else setOrientationWarning(false)
  }

  return (
    <Container className="add-to-basket">
      {!Boolean(cookies.validateAge) && (
        <>
          <Modal
            isOpen={!Boolean(cookies.validateAge)}
            className="age-gate"
            overlayClassName="age-gate-overlay"
            closeTimeoutMS={250}
          >
            <div className="age-gate-msg">
              <div className="content">
                <h2>Age Verification</h2>
                <p>
                  To use the Vuse website you must be aged 18 years or over. Our
                  products are for adult nicotine or tobacco consumers only.
                  Please verify you age before entering the site.
                </p>
              </div>
            </div>
            <div className="gate-btns">
              <button onClick={() => ageGateRedirect()}>I am under 18</button>
              <button
                className="gate-primary-btn"
                onClick={() => addAgeCookie()}
              >
                I am 18 or over
              </button>
            </div>
          </Modal>

          <Modal
            isOpen={notOldEnough}
            className="age-gate"
            overlayClassName="age-gate-overlay"
          >
            <div className="age-gate-msg">
              <div className="content">
                <h2>We're Sorry</h2>
                <p>
                  You must be over 18 to use the VUSE website, you will be
                  redirected to Google in 5 seconds.
                </p>
              </div>
            </div>
          </Modal>
        </>
      )}

      {/* Display warning when device orientation is in landscape */}
      {is_touch_device() && (
        <Modal
          className={{
            base: 'count-in-modal',
            afterOpen: 'modal--after-open',
            beforeClose: 'modal--before-close',
          }}
          overlayClassName={{
            base: 'modal-overlay',
            afterOpen: 'modal--after-open',
            beforeClose: 'modal--before-close',
          }}
          style={{
            overlay: { background: 'rgba(0,0,0,0.9)', zIndex: 600 },
          }}
          isOpen={orientationWarning}
          closeTimeoutMS={500}
        >
          <span className="modal-badge">
            <img
              src="/assets/rotate-portrait.png"
              alt="Please turn your device to portrait"
              width="100"
            />
            <br />
            Please turn your device to portrait.
          </span>
        </Modal>
      )}

      {/* this is visible everywhere */}
      {/* <GameLogo top right fill={logoFill}/> */}

      {/* game timer */}
      {!isEnded && !isHowToPlay && isPlaying && (
        <>
          <Countdown
            time={
              is_touch_device() ? gameTimeLimitMobile : gameTimeLimitDesktop
            }
            started={!countInModal}
            top
            center
            onEndTime={onTimeout}
          />
          <div className="score">
            <div className="count">{_.padStart(collectCount, 1, '0')}</div>
          </div>
        </>
      )}

      {/* timeout modal view */}
      {isEnded && !isHowToPlay && (
        <>
          <GameLogo top right fill="white" />
          <Countdown
            time="00"
            // started={!countInModal}
            top
            center
            // onEndTime={onTimeout}
          />
          <div className="score">
            <div className="count">{_.padStart(collectCount, 1, '0')}</div>
          </div>

          <TimeoutModal onRestartGame={onGameRestart} onFinishGame={finished} />
        </>
      )}

      {/* graphics to overlap to the actual game */}
      {isPlaying && onPlaying() && (
        <>
          <div className="score">
            <div className="count">{_.padStart(collectCount, 1, '0')}</div>
          </div>

          <Modal
            className={{
              base: 'count-in-modal',
              afterOpen: 'modal--after-open',
              beforeClose: 'modal--before-close',
            }}
            overlayClassName={{
              base: 'modal-overlay',
              afterOpen: 'modal--after-open',
              beforeClose: 'modal--before-close',
            }}
            isOpen={countInModal}
            closeTimeoutMS={500}
          >
            <span
              className={`count-in-badge ${
                userCountIn === 0 ? 'count-in-start' : ''
              }`}
            >{`${userCountIn}`}</span>
            <ControlsHint />
          </Modal>

          {is_touch_device() && (
            <div className="text controls-warning">
              Refresh browser if Vuse device <br /> doesn't move
            </div>
          )}
        </>
      )}

      {debug && <div id="gamma">000</div>}

      {isPlaying && (
        <>
          <GameLogo top right fill="white" />
          <canvas id="canvas"></canvas>
        </>
      )}
      {/*<div id="basket" className="basket"></div>*/}

      {!isStarted && Boolean(cookies.validateAge) && (
        <div id="splash">
          <GameLogo top right fill="white" />
          <div className="preview">
            <img
              src="/assets/header-desktop.png"
              alt=""
              className="header-img desktop-only"
              width="100%"
            />
            <img
              src="/assets/header-mobile.png"
              alt=""
              className="header-img mobile-only"
              width="100%"
            />
            <Spacer flex={0.2} />
            <div>
              <div className="title">
                FLAVOUR <br />
                DROP
              </div>
              <div className="text">
                CATCH 20 FLAVOUR DROPS TO GET A<br />{' '}
                <strong>FREE PACK OF PODS*</strong> OR FREE DELIVERY.
              </div>
              <button
                id="btnPlay"
                className="btn btn-primary"
                onClick={() => onPressStart()}
                style={{ margin: '0 auto 20px auto' }}
              >
                Play Now
              </button>
              <button
                className="btn"
                onClick={() => onHowToPlay()}
                style={{ margin: '0 auto 20px' }}
              >
                How To Play
              </button>
              <p
                className="text"
                onClick={() => openTncs()}
                style={{
                  cursor: 'pointer',
                  margin: '0 auto 70px',
                }}
              >
                <strong>*T&Cs apply. Selected flavours only.</strong>
              </p>
              {/* Terms & Conditions modal */}
              <Modal
                className={infoModalClasses}
                overlayClassName={infoModalOverlayClasses}
                isOpen={tncsView}
                onRequestClose={() => setTncsView(!tncsView)}
                closeTimeoutMS={500}
              >
                <button
                  className="btn-close"
                  onClick={() => setTncsView(!tncsView)}
                >
                  &times;
                </button>
                <div className="modal-content">
                  <TnCs />
                </div>
              </Modal>
            </div>
          </div>
        </div>
      )}

      {/* how to play screen */}
      {isHowToPlay && (
        <div className="preview-how-to-play">
          <GameLogo top right fill="white" />
          <HowToPlay start={() => onPressStart()} />
        </div>
      )}

      {/*      {didFinish && (
        <div className="score">
          <div className="count">{_.padStart(collectCount, 1, '0')}</div>
        </div>
      )}*/}

      {/* results screen */}
      {didFinish && (
        <>
          <GameLogo top right fill="white" />
          <GameOver
            className="modal-overlay"
            title={
              collectCount >= maxCount ? (
                <>
                  YOU’VE EARNED A<br /> FREE PACK OF PODS
                </>
              ) : (
                <>
                  You've earned{' '}
                  <span style={{ whiteSpace: 'nowrap' }}>free shipping</span>
                  <br />
                  on your next purchase
                </>
              )
            }
            message={
              // collectCount >= maxGoalCount ? (
              <>
                {/* Play again, or submit <br className="mobile-only" /> */}
                {/* your email to <br className="desktop-only" /> */}
                {/* receive your code*. */}
                Submit your email to
                <br className="mobile-only" /> receive your code*
              </>

              // ) : (
              //   <>
              //     Play again to beat your score, or submit{' '}
              //     <br className="mobile-only" />
              //     your email to <br className="desktop-only" />
              //     receive your code*.
              //   </>
              // )
            }
            score={collectCount}
            maxGoalCount={maxCount}
            button={collectCount >= maxCount ? 'PLAY AGAIN' : 'BEAT YOUR SCORE'}
            onPress={restart}
            onSubmission={() => submitted()}
            collectEmailRef={makeUserEmailRef}
          />
        </>
      )}

      {didSubmit && (
        <>
          <GameLogo top right fill="white" />
          <SuccessView
            title={<>Sent!</>}
            message={
              <p>
                Your discount code has been <br className="mobile-only" />
                sent to
                <br className="desktop-only" /> your email.
              </p>
            }
            onPress={onGameRestart}
            userEmailRef={userEmailRef}
          />
        </>
      )}
    </Container>
  )
}

export default AddToBasket
